<template>
  <div class="input_wrapper" id="inputWrapper" ref="inputWrapper">
    <!-- 未登录 -->
    <div class="no_login" v-show="login">
      <div class="left_area" @click="goLogin">
        亲！请
        <span>登录</span>以后发言。
      </div>
      <div class="send_btn">发送</div>
    </div>
    <!-- 已经登录 -->
    <div class="login" v-show="!login">
      <div class="top_header">
        <div class="login_top clear">
          <div class="left_area" ref="inputArea">
            <Content
              :canEdit="canEdit"
              ref="content"
              :value="imgContent"
              @input="getAllContent"
              @scrollTop="scrollTop"
            />
          </div>
          <button class="send_btn" @click="sendMsg">发送</button>
        </div>
        <div class="login_bottom">
          <ul>
            <li
              v-for="(item,index) in inputArr"
              :key="index"
              :class="[{'active':showActive == index},`list_${item}`]"
              @click="showBox(item,index)"
            >{{item}}</li>
            <!-- <li class="list_img">
              <label>
                <input type="file" @change="addImg($event)" />
              </label>
            </li>-->
          </ul>
          <!-- <van-uploader :before-read="beforeRead" :after-read="afterRead" /> -->
        </div>
      </div>

      <div v-show="showFaceList" class="face_panel clear">
        <ul>
          <li v-for="(item,index) in faceArr" class="li_img" :key="index" @click="choiceFace(item)">
            <img class="face_img" :src="item" alt />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./components/content";
import { toast } from "assets/commonjs/toast";
import { getStore } from "assets/commonjs/storage";
import { clearMsgHtml, isBlank } from "assets/commonjs/tool";
export default {
  data() {
    return {
      inputArr: ["face", "lock"],
      showActive: "-1",
      login: false,
      showFaceList: false,
      lock: false,
      faceArr: [],
      faceFull: false, // 是否填充了表情框
      talkContent: "",
      canEdit: true,
      imgContent: ""
    };
  },
  props: ["liveId", "companyId"],
  mounted() {
    this.makeFace();
    document.onclick = e => {
      if (
        (e.target.className == "active list_face" && this.showActive == 0) ||
        e.target.className == "face_img" ||
        e.target.className == "li_img"
      ) {
        this.showFaceList = true;
      } else {
        this.showFaceList = false;
      }
    };
    // var u = navigator.userAgent;
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    // if (isAndroid) {

    // var originHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // window.addEventListener('resize', function () {
    //   var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   if (originHeight < resizeHeight) {
    //     alert('Android 键盘收起啦！');
    //     // Android 键盘收起后操作
    //     this.$emit('hideBg')
    //   }
    //   originHeight = resizeHeight;
    // }, false)

    // }
  },
  components: {
    Content
  },
  beforeDestroy() {
    window.onresize = null; //注销window.onresize事件
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
    clearContent() {
      this.$refs.content.clearText();
      this.talkContent = "";
    },
    showBox(item, index) {
      this.showActive = index;
      if (index == 0 && this.showFaceList == true) {
        this.showFaceList = false;
        this.showActive = "-1";
      } else if (index != 0) {
        this.showFaceList = false;
      }
      if (
        getStore("noneheader") != null &&
        getStore("noneheader") != "" &&
        getStore("noneheader") != undefined
      ) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        if (isAndroid) {
          this.$emit("hideBg");
        }
      }
      if (index == 1 && this.lock == false) {
        this.showActive = 1;
        this.lock = true;
        this.$emit("lockScreen", true);
      } else if (index == 1 && this.lock == true) {
        this.lock = false;
        this.showActive = "-1";
        this.$emit("parentScrollTop");
        this.$emit("lockScreen", false);
      }
    },
    choiceFace(src) {
      let img = document.createElement("img");
      img.src = src;
      img.style.width = '25px';
      img.style.height = '25px';
      this.$refs.content.addChild(img);
      this.showFaceList = true;
    },
    getAllContent(val) {
      let height = this.$refs.inputArea.offsetHeight;
      if (height > 36) {
        this.$emit("addHeight");
        if (this.lock == false) {
          this.$emit("parentScrollTop");
        }
      } else {
        this.$emit("resetHeight");
      }
      let newVal = this.filterTalkContent(val);
      this.talkContent = newVal;
    },
    // 处理发送的文字
    filterTalkContent(content) {
      let msg = clearMsgHtml(content);
      if (isBlank(msg)) {
        this.talkContent = "";
        toast("发送内容不能为空");
        return false;
      }
      return msg;
    },
    scrollTop() {
      if (this.lock == false) {
        this.$emit("parentScrollTop");
      }

      if (
        getStore("noneheader") != null &&
        getStore("noneheader") != "" &&
        getStore("noneheader") != undefined
      ) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        // alert(isAndroid)
        if (isAndroid) {
          this.$emit("focus");
          document.getElementById("inputWrapper").style.bottom = "4.5rem";
        }
      }
    },
    blur() {
      if (
        getStore("noneheader") != null &&
        getStore("noneheader") != "" &&
        getStore("noneheader") != undefined
      ) {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        if (isAndroid) {
          document.getElementById("inputWrapper").style.bottom = "0";
        }
      }
    },
    makeFace: function() {
      for (var i = 1; i <= 75; i++) {
        // 根据表情文件数量决定循环次数，这里为75个表情
        if (i!=37) this.faceArr.push(`https://static.chwenda.com/source/faceImage/${i}.png`)
      }
    },
    // 压缩图片
    compress(img, callback) {
      img.onload = () => {
        const limitWidth = arguments[2] ? arguments[2] : 200;
        const width = img.width > limitWidth ? limitWidth : img.width;
        const height =
          img.width > limitWidth
            ? parseInt((img.height * limitWidth) / img.width)
            : img.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height); //后四个为位置参数，左上角x,y坐标，右下角x,y坐标
        callback(canvas.toDataURL("image/jpeg", 0.1));
      };
    },
    checkFileSize: function(file) {
      var mfileSize = file.size;
      if (mfileSize >= 1054993) {
        return false;
      }
      return true;
    },
    checkFileType(file) {
      let extName = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      let AllUpExt = ".bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|";
      if (AllUpExt.indexOf(extName + "|") == "-1") {
        return false;
      }
      return true;
    },
    afterRead(file) {
      let _this = this,
        data;
      let res = file.content;
      // console.log(res.length)
      this.$emit("showImgLoad");
      let img = new Image();
      img.src = res;
      _this.compress(img, compressRes => {
        data = compressRes;
        // console.log(data.length)
        _this.sendMsg(data, "image");
      });
      // 此时可以自行将文件上传至服务器
    },
    beforeRead(file) {
      if (this.checkFileSize(file)) {
        return true;
      } else {
        toast("图片不能超过1M");
        return false;
      }
    },
    sendMsg(string, label) {
      if (label == "image") {
        let imagesObj = {
          val: string,
          label: "image"
        };
        this.$emit("sendMsg", imagesObj);
      } else {
        if (this.talkContent == "") {
          if (
            getStore("noneheader") != null &&
            getStore("noneheader") != "" &&
            getStore("noneheader") != undefined
          ) {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            if (isAndroid) {
              this.$emit("hideBg");
            }
          }

          toast("发送内容不能为空");
          return;
        }
        this.$emit("sendMsg", this.talkContent);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.input_wrapper {
  padding: 0.15rem 0;
  position: fixed;
  bottom: 0;
  z-index: 10;
  background: #f4f4f6;
  // width: 100%;
}
.no_login {
  @include fj();
  padding: 0 0.3rem;
}
.top_header {
  padding: 0 0.3rem 0.1rem;
}
.left_area {
  border: 0.025rem solid #c1c1c1;
  background: #fff;
  border-radius: 0.06rem;
  @include sc(0.3rem, #333);
  padding: 0 0.21rem;
  // line-height: 0.64rem;
  width: 5.4rem;
  margin-right: 0.1rem;
  min-height: 0.64rem;

  span {
    padding: 0.07rem 0.28rem;
    @include sc(0.28rem, #fff);
    background: #0a95ff;
    text-align: center;
    border-radius: 0.06rem;
    margin: 0 0.22rem;
  }
}

.send_btn {
  padding: 0 0.38rem;
  text-align: center;
  @include sc(0.28rem, #fff);
  background: #0a95ff;
  border-radius: 0.06rem;
  line-height: 0.64rem;
}
.login_bottom {
  display: flex;
  padding-top: 0.1rem;
  ul {
    display: flex;
    align-items: center;
    padding-left: 0.2rem;
    li {
      @include wh(0.44rem, 0.44rem);
      @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
      font-size: 0;
      margin-right: 0.5rem;
    }
    li.list_face {
      background-position: -0.74rem -1.28rem;
    }
    li.list_face.active {
      background-position: -1.1rem -0.1rem;
    }
    li.list_lock {
      background-position: -2.38rem -0.1rem;
    }
    li.list_lock.active {
      background-position: -1.74rem -0.1rem;
    }
    li.list_img {
      position: relative;
      background-position: -1.38rem -1.28rem;
    }
    li.list_img.active {
      background-position: -0.1rem -1.28rem;
    }
  }
}
.login_top {
  font-size: 0;
  display: flex;
  align-items: flex-end;
}
.face_panel {
  background: #fff;
  padding: 0 0.2rem;
  height: 3.5rem;
  overflow-y: scroll;
  ul {
    li {
      float: left;
      font-size: 0;
      padding: 0.1rem;
      img{
        width: .5rem;
        height: .5rem;
      }
    }
  }
}
input[type="file"] {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
  height: 0.3rem;
}
.login_bottom::v-deep .van-uploader {
  position: relative;
  @include wh(0.44rem, 0.44rem);
  @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
  font-size: 0;
  margin-right: 0.5rem;
  background-position: -1.38rem -1.28rem;
}
.van-uploader::v-deep van-uploader__upload {
  width: 100%;
  height: 100%;
}
.login_bottom::v-deep .van-uploader__upload-icon {
  font-size: 0;
}

.login_bottom::v-deep .van-uploader__input {
  width: 0.44rem;
  height: 0.44rem;
}
.login_bottom::v-deep .van-uploader__upload {
  background: none;
  border: none;
}
</style>